import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const POLICY = [
  {
    title: 'No Returns on Custom Orders',
    body: 'All outfits are made-to-order and handcrafted, therefore returns are not accepted once the order is confirmed.',
  },
  {
    title: 'Exchange Eligibility (Only in Specific Cases)',
    body: 'We offer exchanges only if:',
    list: [
      'The product has a manufacturing defect, or',
      'You receive the wrong item.',
    ],
    note: 'The issue must be reported within 48 hours of delivery with clear photos and videos.',
  },
  {
    title: 'Size & Fit Responsibility',
    list: [
      'Since pieces are customised, customers must provide accurate measurements.',
      'We are not responsible for fitting issues due to incorrect measurements.',
      'Minor alterations can be guided but not always covered.',
    ],
  },
  {
    title: 'Colour & Fabric Disclaimer',
    list: [
      'Slight variations in colour may occur due to lighting and screen differences.',
      'Handwork and dyeing may carry natural irregularities — these are part of the craft, not defects.',
    ],
  },
  {
    title: 'Alterations Policy',
    list: [
      'We may offer paid alteration support (optional), depending on the design and location.',
      'Shipping costs for alterations are borne by the customer.',
    ],
  },
  {
    title: 'Order Cancellation',
    list: [
      'Orders can only be cancelled within 24 hours of placing the order.',
      'After that, production begins and cancellation is no longer possible.',
    ],
  },
  {
    title: 'Refund Policy',
    list: [
      'Refunds are processed only in case of confirmed defects or non-availability of replacement.',
      'Refunds will be issued via the original payment method.',
    ],
  },
];

const ReturnsExchangePage = () => {
  return (
    <section className="policy-page" data-testid="returns-exchange-page">
      <SEO
        title="Returns &amp; Exchange Policy"
        description="Return, exchange, alteration, cancellation and refund terms for every Silk & Sentiment commission."
        path="/returns-exchange"
        type="article"
      />
      <div className="luxury-container">
        <Link to="/" className="policy-back" data-testid="policy-back">
          <ArrowLeft size={16} />
          <span>Back to Home</span>
        </Link>

        <header className="policy-hero">
          <p className="policy-eyebrow">Atelier Policy</p>
          <h1 className="heading-1 policy-title">Returns &amp; Exchange</h1>
          <span className="policy-rule" aria-hidden="true" />
          <p className="policy-lead">
            Each Silk &amp; Sentiment piece is crafted especially for you. Please review our
            atelier terms before placing a commission — we believe transparency is the kindest
            form of luxury.
          </p>
        </header>

        <div className="policy-grid">
          {POLICY.map((p, i) => (
            <article
              key={p.title}
              className="policy-card"
              data-testid={`policy-card-${i + 1}`}
            >
              <span className="policy-card__num">{String(i + 1).padStart(2, '0')}</span>
              <div>
                <h3 className="policy-card__title">{p.title}</h3>
                {p.body && <p className="policy-card__body">{p.body}</p>}
                {p.list && (
                  <ul className="policy-card__list">
                    {p.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
                {p.note && <p className="policy-card__note">{p.note}</p>}
              </div>
            </article>
          ))}
        </div>

        <div className="process-cta-card" style={{ marginTop: 64 }}>
          <h2 className="heading-2">Questions before you commission?</h2>
          <p>
            We respond to every message within 48 hours. Reach out via the form below or directly
            on WhatsApp — we&rsquo;ll guide you through every step.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn-primary">Contact the Atelier</Link>
            <Link to="/order-process" className="btn-secondary">View Order Process</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReturnsExchangePage;
